import {app}                         from '../../app';
import IScope = angular.IScope;
import {SharedQuestionService}       from '../../services/SharedQuestionService';
import {ISessionService}             from '../../services/SessionService';
import {UniqueIdService}             from '../../services/UniqueIdService';
import {SelectQuestionComponent}     from './SelectQuestionComponent';
import {SelectNumericSharedQuestion} from '../../sharedQuestions/SelectNumericSharedQuestion';
import {createLanguageServiceHost}   from 'tslint/lib/language/languageServiceHost';

export class SelectNumericQuestionComponent extends SelectQuestionComponent {

    constructor(sharedQuestionService:SharedQuestionService, sessionService:ISessionService, uniqueIdService:UniqueIdService) {
        super(sharedQuestionService, sessionService, uniqueIdService);
    }

    setup() {
        this.sharedQuestion = new SelectNumericSharedQuestion();

        let meta        = this.question.meta,
            choicesFrom = meta.choicesFrom,
            choicesTo   = meta.choicesTo;

        if (isFinite(choicesFrom) && isFinite(choicesTo)) {
            for (let i = choicesFrom; i <= choicesTo; i++) {
                this.choices.push(i.toString());
            }
        }

        super.setup(false);
    }

}

app.component('selectNumericQuestion', {
    templateUrl : 'templates/components/questionTypes/selectQuestion.html',
    controller  : SelectNumericQuestionComponent,
    controllerAs: 'selectQuestion',
    bindings    : {
        question            : '<',
        nextQuestionCallback: '&'
    }
});